import ContactLinks from './ContactLinks';

export default ContactLinks;
